const Spinner = (props) => {
  return (
    <>
      <div
        className="spinner"
        style={{
          width: "700px",
          height: "350px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "0px",
        }}
      >
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
    </>
  );
};

export default Spinner;
